// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__e6CJU","footer":"ReportModalFilter_footer__1k8tO"};